import { Button } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useRedirectPortal } from '../hooks'

export function StripePortalButton() {
    const stripeRedirectMutation = useRedirectPortal()
    const { t } = useTranslation()

    return (
        <Button
            loading={stripeRedirectMutation.isPending}
            onClick={() => stripeRedirectMutation.mutateAsync().then((url) => window.open(url))}
        >
            {t('Stripe Portal')}
        </Button>
    )
}
